<div kalDialogContent
     [kalLoading]="loading">

    <app-shared-advanced-rule-detail *ngIf="rule" [isInteractivity]="!!data.isInteractivity"
                                       [rule]="rule"
                                       isDialog
                                       [activityType]="data.activityType"
                                       [isPlanning]="data.isPlanning"
                                       [complementarySubvention]="data.complementarySubvention">

        <app-shared-advanced-rule-detail-table [context]="data.context"
                                               [ruleList]="rule.ReglesEnfants"
                                               [ruleType]="ruleType">
        </app-shared-advanced-rule-detail-table>

    </app-shared-advanced-rule-detail>

</div>

<div kalDialogFooter>
    <kal-button kalTheme="secondary"
                (click)="close()">
        Fermer
    </kal-button>
</div>
